export function formatRevenue(amount) {
    if (amount == null || !Number.isFinite(amount)) return '$0';
    if (amount >= 1e9) return `$${(amount / 1e9).toFixed(1)}B`;
    if (amount >= 1e6) return `$${(amount / 1e6).toFixed(1)}M`;
    if (amount >= 1e3) return `$${Math.round(amount / 1e3)}K`;
    return `$${Math.round(amount)}`;
}
